import React from "react";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { Dialog } from 'primereact/dialog';

const Container = tw(ContainerBase)`min-h-screen bg-gray-100 text-gray-900 font-medium flex justify-center items-center`;
const Content = tw.div`bg-white rounded-2xl shadow-lg w-full max-w-xl p-8`;
const Heading = tw.h1`text-2xl font-bold mb-6 text-center text-red-600`;
const ButtonRow = tw.div`flex justify-between space-x-4`;
const Button = styled.button`
  ${tw`w-full py-3 rounded-md font-semibold text-sm transition duration-300`}
`;

const CancelButton = styled(Button)`
  ${tw`bg-gray-300 text-gray-800 hover:bg-gray-400`}
`;

const DeleteButton = styled(Button)`
  ${tw`bg-red-500 text-white hover:bg-red-600`}
`;

export default function DeleteJobModal({ visible, setVisible, onConfirm }) {
  return (
    <Dialog
      visible={visible}
      modal
      dismissableMask
      onHide={() => setVisible(false)}
      breakpoints={{ '960px': '90vw' }}
      style={{ width: '30vw' }}
      contentStyle={{ padding: 0, borderRadius: '1rem', maxHeight: '90vh', overflowY: 'auto' }}
      maskClassName="bg-black bg-opacity-50"
    >
      <div className="overflow-y-auto max-h-[85vh]">
        <Container>
          <Content>
            <Heading>Are you sure you want to delete this job?</Heading>
            <p className="text-center text-sm text-gray-600 mb-6">
              This action cannot be undone.
            </p>
            <ButtonRow>
              <CancelButton type="button" onClick={() => setVisible(false)}>
                Cancel
              </CancelButton>
              <DeleteButton type="button" onClick={() => {
                onConfirm();
                setVisible(false);
              }}>
                Delete
              </DeleteButton>
            </ButtonRow>
          </Content>
        </Container>
      </div>
    </Dialog>
  );
}
